// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerInfoLinksContainerStyles } from "@steiner/App/Components/Footer/FooterInfoLinksContainer";
import { color, layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

footerInfoLinksContainerStyles.container = {
    css: css`
        background-image: linear-gradient(
            90deg,
            ${color("common.ui6")} 0%,
            ${color("common.ui6")} 75%,
            ${color("common.ui17")} 75%,
            ${color("common.ui17")} 100%
        );

        ${xScreen("lte", "md")} {
            background: ${color("common.ui6")};
        }
    `,
};

footerInfoLinksContainerStyles.innerContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 382px;
        gap: 20px 22px;

        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }

        ${layoutContainer}
    `,
};

footerInfoLinksContainerStyles.leftSection = {
    css: css`
        display: grid;
        grid-template-columns: 317px repeat(2, auto);
        gap: 20px 22px;
        padding-top: 20px;
        padding-bottom: 20px;
        grid-area: 1 / 1 / 2 / 2;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(3, 1fr);
        }
        ${xScreen("lt", "sm")} {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px 16px;
        }
    `,
};

footerInfoLinksContainerStyles.rightSection = {
    css: css`
        padding-top: 20px;
        padding-bottom: 20px;
        background: ${color("common.ui17")};

        ${xScreen("gt", "lg")} {
            grid-area: 1 / 2 / 2 / 3;
            clip-path: polygon(48px 0, 100% 0, 100% 100%, 0 100%);
            padding-left: 64px;
        }

        ${xScreen("lte", "md")} {
            grid-area: 2 / 1 / 3 / 2;
            box-shadow: 0 0 0 100vmax ${color("common.ui17")};
            clip-path: inset(0 -100vmax);
        }
    `,
};
